const type = 'RESET_EDIT_ACCOUNT_PARAMETER';

const resetEditAccountParameter = () => ({
  type,
});

export { type };
export default resetEditAccountParameter;
